import { createAction, props } from '@ngrx/store';
import { Quote } from '../../models/quote';
import { ShipmentQuoting } from '../../models/shipment-quoting';
import { ServerMessage } from '../../models/server-message';

export const quotingStart = createAction(
    '[Shipment] Start Quoting',
    props<{ id: string }>()
);

export const quotingStartMulti = createAction(
    '[Shipment] Start Quoting Multiple Shipments from Selection'
);

export const quotingPendingSave = createAction(
    '[Shipment] Quoting Pending Save Success',
    props<{ id: string }>()
);

export const quotingUpdate = createAction(
    '[Messages] Quote Update Received',
    props<{ id: string, messages: ServerMessage[], progress: number, quotes: Quote[] }>()
);

export const quotingCompleted = createAction(
    '[Action] Quoting Complete for Shipment',
    props<{ id: string, messages: ServerMessage[], quotes: Quote[] }>()
);

export const quotingClose = createAction(
    '[Shipment] Close the Quoting Page',
    props<{ id: string }>()
);

export const quotingFocus = createAction(
    '[Shipment] Focus on single Quote',
    props<{ id: string }>()
);

export const quotingFailed = createAction(
    '[Action] Quoting completed but failed',
    props<{ id: string, messages: ServerMessage[] }>()
);

export const quotingCompleteMulti = createAction(
    '[Action] Quoting Multi Completed',
    props<{ results: ShipmentQuoting[] }>()
);

export const quotingFailedMulti = createAction(
    '[Action] Quoting Multi completed but failed',
    props<{ ids: string[], messages: ServerMessage[] }>()
);

export const quotingCheckTerms = createAction(
    '[Quoting] Check Terms Before Proceeding',
    props<{ id: string }>()
);

export const quotingTermsRequired = createAction(
    '[Quoting] Terms Required',
    props<{ id: string, termsIds: string[] }>()
);

export const quotingShowTerms = createAction(
    '[Quoting] Show Terms Acceptance Modal',
    props<{ id: string, termId: string }>()
);

export const quotingTermsAccepted = createAction(
    '[Quoting] Terms Accepted by User',
    props<{ id: string, termId: string }>()
);

export const quotingTermsDeclined = createAction(
    '[Quoting] Terms Declined by User',
    props<{ id: string }>()
);
